import request from "../libs/request";

import { RentStatusValue } from "../types/rentTypes";
import { GoodsStoreJsonCode, ReturnStoreType } from "../types/goods";
import { ServiceStatusValue } from "../types/serviceTypes";

import { BuildingId } from "../types/building";

import { SatisfactionInfo } from "./spaceReservationServices";

const baseUrl = "/goods/request";

export type GoodsServiceItem = {
  goodsServiceItemsId: string;
  goodsId: string;
  goodsName: string;
  goodsDescription: string;
  requestCount: number;
};

export type GoodsServiceItemRequest = {
  goodsId: string;
  count: number;
};

export type GoodsServiceRequestType = "REFILL" | "PICK_UP";

export const getServiceRequestStep: {
  [key: string]: number;
} = {
  REQUESTED: 1,
  CANCELED: 0,
  COMPLETED: 2,
};

export type GoodsServiceRequest = BuildingId & {
  companyId: string;
  requestBuildingFloorId?: string;
  requestType: GoodsServiceRequestType;
  extraRequest: string;
  usedDepartment: string;
  goodsServiceItemList: GoodsServiceItemRequest[];
};

export type GoodsServiceRequestDetail = BuildingId & {
  goodsServiceId: string;
  buildingName: string;
  companyId: string;
  companyName: string;
  status: ServiceStatusValue;
  requestType: GoodsServiceRequestType;
  requestBuildingFloorId: string;
  requestBuildingFloorName: string;
  usedDepartment: string;
  extraRequest: string;
  goodsServiceItemList: GoodsServiceItem[];
  createdBy: number;
  createdByName: string;
  createdAt: string;
  modifiedBy: number;
  modifiedByName: string;
  modifiedAt: string | null;
  canceledBy: number;
  canceledByName: string;
  canceledAt: string;

  completedBy: number;
  completedAt: string;
  adminNotes: string;

  satisfactionInfo?: SatisfactionInfo;
  activeRentalHistory: GoodsServiceRentItem;
};

export const createGoodsServiceRequest = async (params: GoodsServiceRequest) =>
  request.post<GoodsServiceRequestDetail>(`${baseUrl}`, params);

export const putGoodsServiceRequest = async (
  goodsServiceId: string,
  params: GoodsServiceRequest
) =>
  request.put<GoodsServiceRequestDetail>(
    `${baseUrl}/${goodsServiceId}`,
    params
  );

export const cancelGoodsServiceRequest = async (goodsServiceId: string) =>
  request.patch<GoodsServiceRequestDetail>(
    `${baseUrl}/${goodsServiceId}/cancel`
  );

export const getGoodsServiceItems = async (
  companyId: string,
  goodsRequestType: GoodsServiceRequestType
) =>
  request.get<GoodsServiceItem[]>(
    `${baseUrl}/list/goods/${companyId}/${goodsRequestType}`
  );

export const getGoodsServiceDetail = async (goodsServiceId: string) =>
  request.get<GoodsServiceRequestDetail>(`${baseUrl}/detail/${goodsServiceId}`);

export type GoodsServiceRentItem = {
  goodsServiceId: string;
  rentStockId: string;
  returnStockId: null;
  status: RentStatusValue;
  goodsId: string;
  goodsTypeId: string;
  goodsTypeName: string;
  rentalHour: number;
  goodsName: string;
  goodsDescription: string;
  serviceGroupId: string;
  rentalBuildingId: string;
  rentalBuildingName: string;
  rentalStoreId: string;
  rentalStoreName: string;
  returnBuildingId: null;
  returnBuildingName: null;
  returnStoreId: null;
  returnStoreName: null;
  rentalAt: string;
  returnDueAt: string;
  actualReturnAt: null;
  lostDamagedAt: null;
  isReturnByAdmin: null;
  createdAt: string;
  canceledAt: string | null;
  createdBy: number;

  categoryNameS: string;
  categoryNameM: string;
  satisfactionInfo?: SatisfactionInfo;
  createdByCompanyName: string;
  createdByName: string;
  returnStoreList: ReturnStoreType[];
};

export const completeGoodsServiceItem = async (
  goodsServiceId: string,
  params: GoodsStoreJsonCode
) =>
  request.put<GoodsServiceRentItem>(
    `${baseUrl}/${goodsServiceId}/complete`,
    params
  );

export const rentGoodsServiceItem = async (
  goodsServiceId: string,
  params: GoodsStoreJsonCode
) =>
  request.put<GoodsServiceRentItem>(
    `${baseUrl}/${goodsServiceId}/rented`,
    params
  );
